import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
// assets
import LogoutIcon from "../../assets/icons/icon-logout.svg";
// components
import ListDrawer from "../list/ListDrawer";
// recoil
import { useRecoilValue } from 'recoil';
import { userInfo, routeInfo } from '../../recoilState/GlobalState';
import { logout } from "../../services/Local-services";
// styles
import { HeaderStyles } from "./Header.styles";

export default function Header() {
    const [openDrawer, setOpenDrawer] = useState(false);
    const info = useRecoilValue(userInfo);
    const route = useRecoilValue(routeInfo);

    const handleDrawerOpen = () => setOpenDrawer(true);
    const classes = HeaderStyles();

    return (
        <>
            <AppBar
                position="relative"
                sx={{
                    height: '150px',
                    display: 'flex',
                    background: '#f2f2f2',
                    boxShadow: 'none',
                }}
                >
                <Toolbar
                    variant="dense"
                    sx={{
                    marginLeft: '1rem',
                    padding: '3rem'
                    }}
                >
                    <IconButton
                    edge="start"
                    aria-label="menu"
                    color="inherit"
                    onClick={handleDrawerOpen}
                    >
                    <MenuIcon sx={{ color: '#63c3d1' }} />
                    </IconButton>
                    <Typography
                    variant="h4"
                    color="inherit"
                    sx={{
                        color: '#63c3d1',
                        fontSize: '2.5rem',
                        fontWeight: 300,
                        padding: '2rem'
                    }}
                    >
                    {route.wordKey}
                    </Typography>
                </Toolbar>
            </AppBar>

            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
            >
                <div className={classes.userDescription}>
                    <img className={classes.avatar} alt="avatar" src={info.imagePathPERFIL} />
                    <div className={classes.usernameContainer}>
                        <p>{info.usuarioApellidos} {info.usuarioNombres.split(' ')[0]}</p>
                        <div className={classes.logout} onClick={() => logout()}>
                            <img src={LogoutIcon} alt="logout" />
                            <p>Cerrar sesión</p>
                        </div>
                    </div>
                </div>

                <div className={classes.listContainer}>
                    <ListDrawer setOpen={setOpenDrawer} />
                </div>

                <div className={classes.drawerFooter}>
                    ® Hooli | Todos los derechos reservados
                </div>
            </Drawer>

            {openDrawer && (
                <div
                    className={classes.drawerHandler}
                    onClick={() => setOpenDrawer(false)}
                />
            )}
        </>
    );
}